<template>
  <section class="activity property-navigation pt-8">
    <button
        v-for="item in visibleItems" :key="item.label"
        class="text-body-1 fw-semi-bold"
        :class="{selected: item.code === selectedItemCode, 'desktop-only': item.desktopOnly}"
        :aria-label="item.label"
        @click="select(item)"
    >
      {{$t(item.label)}}
    </button>
  </section>
</template>
<script setup lang="ts">

import {scrollToElement, throttle} from '~/utils/common'
import { useActivityPropertyStore } from '~/store/activityProperty'

interface  Item {
  code: string,
  label: string,
  selector: string,
  desktopOnly: boolean
}

const property = useActivityPropertyStore().property

const items:Item[] = [
  {code: 'overview', label: 'Overview', selector: '.property-info__list', desktopOnly: false},
  {code: 'entranceTicket', label: 'Activity package', selector: '#entranceTicket', desktopOnly: false},
  {code: 'experience', label: 'Experience', selector: '#PropertyFacilities', desktopOnly: false},
  {code: 'location', label: 'Location', selector: '#PropertyLocation', desktopOnly: false},
  {code: 'faq', label: 'FAQ', selector: '#PropertyFAQ', desktopOnly: false},
  {code: 'review', label: 'Review', selector: '#PropertyReview', desktopOnly: false},
]

const visibleItems = computed(() => {
  return items.filter(item => {
    if (item.code === 'review' && !(property.avg_rating > 0)) return false
    return true
  })
})
let sectionsElements = [] as any[]

let selectedItemCode = ref(items[0]?.code as string || 'overview')

function select(item: Item) {
  if (item.selector) {
    scrollToElement(item.selector, -100)
  }
}

function getSectionsElements() {
  sectionsElements = []
  visibleItems.value.forEach(item => {
    const el = document.querySelector(item.selector)
    if (el) {
      sectionsElements.push({
        code: item.code,
        element: el
      })
    }
  })
}

function scrollListener() {
  let selectedCode
  let isElementInList: any = false

  for(let i = 0; i < sectionsElements.length; i++) {
    isElementInList = true
    const elPosition = sectionsElements[i].element?.offsetTop
    if ((window.scrollY + 120) < elPosition) {
      break;
    }

    selectedCode = sectionsElements[i].code

    if (selectedCode === 'location') {
      isElementInList = window.scrollY - 120 < elPosition
    }
  }
  selectedItemCode.value = selectedCode || items[0]?.code || 'overview'

  togglePropertyNavigationPosition(isElementInList)
}

function togglePropertyNavigationPosition(isElementInList: any) {
  const _propertyNavigationEl = document?.querySelector('.property-navigation')
  if (!_propertyNavigationEl) return;

  if (!isElementInList) {
    _propertyNavigationEl?.setAttribute('style', 'position: unset')
  } else {
    _propertyNavigationEl?.removeAttribute('style')
  }
}

const scrollListenerThrottle = throttle(scrollListener, 100)

onMounted(() => {
  getSectionsElements()
  window.addEventListener('scroll', scrollListenerThrottle);
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', scrollListenerThrottle);
})

</script>

<style lang="scss" scoped>
.activity.property-navigation {
  display: flex;
  width: 100%;
  max-width: calc(100% - 357px - 24px);
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--white);
  padding-bottom: 8px;

  button {
    flex: auto;
    max-width: 148px;
    height: 44px;
    padding-bottom: 16px;
    border-bottom: 2px solid var(--grey-border);

    //vertical tablet
    @media screen and (max-width: 975px) {
      height: 38px;
    }

    @media screen and (max-width: 430px) {
      min-width: 33.3vw;
    }

    &.selected {
      padding-bottom: 15px;
      border-bottom: 3px solid var(--blue);
      color: var(--blue);

      @media screen and (max-width: 430px) {
        border-bottom-width: 2px;
      }
    }
  }

  @media screen and (max-width: 1024px) and (min-width: 975px) {
    max-width: 608px;
    button {
      flex: 1;
      max-width: 100%;
    }
  }

  //vertical tablet
  @media screen and (max-width: 974px) and (min-width: 431px){
    max-width: 100%;
    button {
      flex: 1;
      max-width: 100%;
    }
  }

  @media screen and (max-width: 430px) {
    $fullLengthWidth: 100vw;
    max-width: $fullLengthWidth;
    min-width: $fullLengthWidth;
    margin-left: -16px;
    overflow-x: auto;
    scrollbar-width: none;
  }

  &.pt-8 {

    @media screen and (max-width: 430px) {
      padding-top: 1.3rem;//20px
    }
  }


}
</style>
